import { Event } from './event';

export class ClosestEventsByType {
  visitClosestEvent: Event;
  reminderClosestEvent: Event;
}
